import Vue from 'vue'
import App from './App.vue'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@/css/style.css';
// import './registerServiceWorker';
// import wb from "./registerServiceWorker";

// Vue.prototype.$workbox = wb;

import  router  from "./router.js";
import './registerServiceWorker'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
